import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="confirm"
export default class extends Controller {
  static targets = ["dialog", "backdrop", "panel"];

  dialogTargetConnected(el) {
    this.dialogEl = el;
  }
  backdropTargetConnected(el) {
    this.backdropEl = el;
  }
  panelTargetConnected(el) {
    this.panelEl = el;
  }

  show(e) {
    e.preventDefault();

    this.dialogParent = this.dialogEl.parentElement;
    this.dialogSibling = this.dialogEl.nextSibling;
    document.body.appendChild(this.dialogEl);

    this.clickHandler = (ev) => {
      if (ev.target === this.backdropEl) {
        this.hide();
        return;
      }
      if (ev.target.closest('[data-action*="confirm#hide"]')) this.hide();
    };
    this.dialogEl.addEventListener("click", this.clickHandler);

    this.submitEndHandler = (ev) => {
      if (ev.detail.success) this.hide();
    };
    document.addEventListener("turbo:submit-end", this.submitEndHandler);

    this.dialogEl.classList.remove("hidden");
    this.dialogEl.classList.add("flex");
    requestAnimationFrame(() => {
      this.backdropEl.classList.add("confirm-backdrop-enter");
      this.panelEl.classList.add("confirm-panel-enter");
    });
  }

  hide() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.close();
      return;
    }

    const backdrop = this.backdropEl;
    const panel = this.panelEl;
    let finished = false;
    let ends = 0;
    const fallbackId = setTimeout(() => this.close(), 400);

    const done = () => {
      if (finished) return;
      finished = true;
      clearTimeout(fallbackId);
      document.body.removeEventListener("animationend", onEnd);
      this.close();
    };

    const onEnd = (e) => {
      if (e.target !== backdrop && e.target !== panel) return;
      if (++ends >= 2) done();
    };

    backdrop.classList.replace(
      "confirm-backdrop-enter",
      "confirm-backdrop-leave",
    );
    panel.classList.replace("confirm-panel-enter", "confirm-panel-leave");
    document.body.addEventListener("animationend", onEnd);
  }

  close() {
    this.dialogEl.removeEventListener("click", this.clickHandler);
    this.clickHandler = null;

    document.removeEventListener("turbo:submit-end", this.submitEndHandler);
    this.submitEndHandler = null;

    this.backdropEl.classList.remove(
      "confirm-backdrop-enter",
      "confirm-backdrop-leave",
    );
    this.panelEl.classList.remove("confirm-panel-enter", "confirm-panel-leave");
    this.dialogEl.classList.remove("flex");
    this.dialogEl.classList.add("hidden");

    if (this.dialogParent) {
      this.dialogParent.insertBefore(this.dialogEl, this.dialogSibling);
      this.dialogParent = null;
      this.dialogSibling = null;
    }
  }
}
